import React from "react";
import { Reveal } from "../components/motion";
import { BrandLogo } from "../components/BrandLogo";
import { Seo } from "../components/Seo";
import { CLIENTELE_INTRO, BRANDS, SECTORS } from "../data/content";

const PageHeader = ({ eyebrow, title, sub }) => (
  <section className="pt-40 pb-16">
    <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
      <Reveal><p className="eyebrow mb-6">{eyebrow}</p></Reveal>
      <Reveal delay={0.1}>
        <h1 className="display text-5xl sm:text-8xl max-w-[16ch]" style={{ color: "var(--text)" }}>{title}</h1>
      </Reveal>
      {sub && <Reveal delay={0.2}><p className="mt-8 max-w-2xl text-lg" style={{ color: "var(--muted-t)" }}>{sub}</p></Reveal>}
    </div>
  </section>
);

const Clientele = () => {
  return (
    <div data-testid="clientele-page">
      <Seo path="/clientele" description="Brands Yuva Kumar has partnered with — Cartier, PepsiCo, Verizon, Telefónica, TPG Telecom, SBI, Mahindra, Intel, Nokia and more across luxury, telecom, CPG, banking and enterprise." keywords="Yuva Kumar clients, enterprise UX clients, PepsiCo, Cartier, Verizon, TPG Telecom, SBI, Mahindra" />
      <PageHeader
        eyebrow="Clientele"
        title="Trusted by global brands."
        sub="Two decades delivering award-winning experiences across luxury, telecom, CPG, and enterprise — for the brands that set the standard."
      />

      {/* Logo wall */}
      <section className="pb-24" data-testid="logo-wall">
        <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-px" style={{ background: "var(--line)" }}>
            {BRANDS.map((b, i) => (
              <Reveal key={b.name} delay={(i % 4) * 0.05}>
                <BrandLogo
                  name={b.name}
                  domain={b.domain}
                  sector={b.sector}
                  testid={`brand-${b.name.toLowerCase().replace(/\s+/g, "-")}`}
                />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Write-up */}
      <section className="py-24" style={{ background: "var(--surface)" }} data-testid="clientele-writeup">
        <div className="mx-auto max-w-[1600px] px-6 sm:px-10 grid lg:grid-cols-[1fr_1.2fr] gap-14">
          <Reveal>
            <h2 className="display text-4xl sm:text-6xl max-w-[12ch]" style={{ color: "var(--text)" }}>{CLIENTELE_INTRO.title}</h2>
          </Reveal>
          <div className="space-y-6">
            {CLIENTELE_INTRO.body.map((p, i) => (
              <Reveal key={i} delay={0.1 + i * 0.1}>
                <p className="text-lg leading-relaxed" style={{ color: "var(--muted-t)" }}>{p}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Sectors */}
      <section className="py-24" data-testid="sectors-section">
        <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
          <Reveal><p className="eyebrow mb-10">Industries & Sectors</p></Reveal>
          <div className="flex flex-wrap gap-3">
            {SECTORS.map((s, i) => (
              <Reveal key={s} delay={i * 0.04}>
                <span className="inline-block px-6 py-3 border rounded-full text-sm" style={{ borderColor: "var(--line)", color: "var(--text)" }}>{s}</span>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Clientele;
